import React from "react";
import styled from "styled-components";
import { useTranslation, Trans } from "react-i18next";
import { MAX_CONTENT_WIDTH } from "components/styled/mixins";
import { white } from "utils/constants/colors";
import DocLink from "components/common/DocLink";
import Button from "components/ui/Button";
import ClusterProfileBuildingBlockLayers from "assets/images/clusterProfile/clusterProfileBuildingBlocks.png";

const Wrap = styled.div`
  max-width: ${MAX_CONTENT_WIDTH};
  display: flex;
  flex-direction: row;
  overflow: hidden;
  height: 100%;
  justify-content: center;
  align-items: center;
  background-color: ${white};
`;

const LeftContent = styled.div`
  width: 480px;
  height: 358px;
  display: flex;
  flex-direction: column;
  padding-right: 64px;
  justify-content: center;
  button {
    width: 200px;
    margin: 20px 15px 0 0;
  }
`;

const SubTitleWrap = styled.div`
  font-size: 24px;
  font-style: normal;
  font-weight: 500;
  line-height: 28px;
  color: #111626;
  padding-bottom: 20px;
  padding-top: 10px;
`;

const SubContent = styled.div`
  color: #545f7e;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  padding-bottom: 24px;
`;

const ClusterProfileIllustration = styled.div`
  width: 509px;
  height: 488px;
  height: 358px;
  background-repeat: no-repeat;
  background-size: contain;
  background-image: url(${ClusterProfileBuildingBlockLayers});
`;

export default function ClusterProfileEmptyInstructions({
  addProfile,
  title = "",
  docLink = null,
}) {
  const { t } = useTranslation();
  return (
    <Wrap>
      <LeftContent>
        <SubTitleWrap>{title || t("Cluster Profile")}</SubTitleWrap>
        <SubContent>
          <Trans>
            Start setting up your cluster by including a <strong>FULL</strong>{" "}
            or <strong>INFRA</strong> cluster profile which contain the required
            layers like OS, Kubernetes, Network and Storage.
          </Trans>
        </SubContent>
        <SubContent>
          <Trans>
            Additionally, enhance it with extra <strong>ADDON</strong> profiles.
          </Trans>
        </SubContent>
        {docLink || (
          <DocLink
            text={t("Learn More about Cluster Profiles")}
            location="cluster-profiles"
          />
        )}
        <Button
          size="large"
          data-qa="add_cluster_profile"
          onClick={() => addProfile()}
        >
          {t("Add Cluster Profile")}
        </Button>
      </LeftContent>
      <div>
        <ClusterProfileIllustration />
      </div>
    </Wrap>
  );
}
